export default __webpack_public_path__ + "static/media/kitchen.1033f89b.png";